/* eslint-disable no-param-reassign */
import { Q } from '@nozbe/watermelondb'
import { of } from 'rxjs'

import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'

import { getAddressesByOrganization } from '@smartcoop/services/apis/smartcoopApi/resources/organization'

const SHOPPING_ORGANIZATION_FIELDS = [
  'shoppingOrganizationId', 'addressComplement', 'city', 'companyDocument', 'companyName', 'country',
  'createdAt', 'district', 'isSubsidiary', 'nfe', 'number', 'organizationId', 'postalCode', 'state',
  'stateRegistration', 'street', 'tradeName', 'updatedAt', 'type'
]

export function shoppingOrganizationService(database) {
  async function createOrUpdate(shoppingOrganizations = [], onFinish = () => {}) {
    await database.write(async () => {
      const promises = shoppingOrganizations.map(shoppingOrganization => async () => {
        const register = await database.get('shoppingOrganization')
          .query(Q.where('shoppingOrganizationId', shoppingOrganization?.id || shoppingOrganization?.shoppingOrganizationId ))
          .fetch()

        if(register[0]) {
          map(register, (item) => {
            item.destroyPermanently()
          })
        }
        await database.get('shoppingOrganization').create(item => {
          SHOPPING_ORGANIZATION_FIELDS.forEach(field => {
            if(field === 'shoppingOrganizationId') {
              item[field] = shoppingOrganization?.shoppingOrganizationId || shoppingOrganization?.id
            } else {
              item[field] = shoppingOrganization?.[field]
            }
          })
        })
      })

      await Promise.all(promises.map(fn => fn()))
      onFinish()
    })
  }

  async function deleteAnimalById(shoppingOrganizationId) {
    await database.write(async () => {
      const register = await database.get('shoppingOrganization')
        .query(Q.where('shoppingOrganizationId', shoppingOrganizationId))
        .fetch()

      if (register[0]) {
        await register[0].markAsDeleted()
      }
    })
  }

  async function clearTable() {
    await database.write(async () => {
      await database.get('shoppingOrganization').query().destroyAllPermanently()
    })
  }

  async function findShoppingOrganizationById(shoppingOrganizationId) {
    return database
      .get('shoppingOrganization')
      .query(Q.where('shoppingOrganizationId', shoppingOrganizationId))
      .fetchOne()
  }

  function observeShoppingOrganizations(shoppingOrganizationsLoading, organizationId = null) {
    if(shoppingOrganizationsLoading) {
      return of([])
    }

    const shoppingOrganizationCollection = database.collections.get('shoppingOrganization')

    return shoppingOrganizationCollection.query(
      Q.or(
        Q.where('organizationId', Q.eq(organizationId)),
        Q.where('shoppingOrganizationId', Q.eq(organizationId))
      )).observe()
  }

  async function syncShoppingOrganizations(params, organizationId, onFinish = () => {}) {
    database.collections.get('shoppingOrganization').query().fetch().then(async result => {
      const { data: { data: response } } = await getAddressesByOrganization(
        { ...params, limit: 999999, updatedAt: isEmpty(result) ? null : params?.updatedAt },
        { organizationId }
      )

      await createOrUpdate(response, onFinish)
    })

  }

  return {
    createOrUpdate,
    clearTable,
    deleteAnimalById,
    findShoppingOrganizationById,
    observeShoppingOrganizations,
    syncShoppingOrganizations
  }
}